import { useTheme } from 'styled-components';

const withHookedTheme = (WrappedComponent) => {
  return function WithHookedTheme(props) {
    const theme = useTheme();
    return <WrappedComponent {...props} theme={theme} />;
  };
};

export default withHookedTheme;
